/**
 * useHaptic — mobile haptic feedback via navigator.vibrate()
 * No-ops gracefully when API is unavailable.
 */

import { useCallback } from 'react';

function vibrate(pattern: number | number[]) {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
}

export function useHaptic() {
  const tap = useCallback(() => vibrate(10), []);
  const success = useCallback(() => vibrate([10, 50, 20]), []);
  const error = useCallback(() => vibrate([30, 50, 30]), []);
  const celebrate = useCallback(() => vibrate([10, 30, 10, 30, 10]), []);

  return { tap, success, error, celebrate };
}
